import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=3223b34c&scoped=true&"
import script from "./templateDetail.vue?vue&type=script&lang=js&"
export * from "./templateDetail.vue?vue&type=script&lang=js&"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=3223b34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223b34c",
  null
  
)

export default component.exports